import { ResearchTopic } from '@/types/research.types';
import driveSourceData from './research.drivesource.json';
import homeSourceData from './research.homesource.json';

function getData(): ResearchTopic[] {
    switch (import.meta.env.VITE_ASSISTANT_DISPLAY_NAME) {
        case 'DriveSource': return driveSourceData as ResearchTopic[];
        case 'HomeSource': return homeSourceData as ResearchTopic[];
        default: return [];
    }
}

export function getResearch(): ResearchTopic[] {
    return getData();
}

export function getResearchBySlug(slug: string): ResearchTopic | undefined {
    return getData().find(r => r.slug === slug);
}
